import { render, staticRenderFns } from "./EditSample.vue?vue&type=template&id=2d3a66aa&scoped=true"
import script from "./EditSample.vue?vue&type=script&lang=js"
export * from "./EditSample.vue?vue&type=script&lang=js"
import style0 from "./EditSample.vue?vue&type=style&index=0&id=2d3a66aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a66aa",
  null
  
)

export default component.exports